import { commonMessages } from '../../util/messages'

export const messages = {
  common: commonMessages,
  trade: {
    create: {
      error: 'There is a problem creating the trades',
      success: 'Trades created successfully',
    },
    update: {
      success: 'Trade updated successfully',
      error: 'Error updating trade',
    },
    delete: {
      success: 'Trade deleted successfully',
    },
  },
  couponDates: {
    update: {
      success: 'Coupon dates updated successfully',
      error: 'Error updating coupon dates',
    },
  },
}
